<script setup lang="ts">
import type { NuxtError } from "#app";

defineProps({
  error: Object as () => NuxtError,
});
</script>

<template>
  <UMain>
    <NuxtLayout>
      <UPageError
        :error="error"
        message="Diese Seite ist nicht vorhanden"
        :clear-button="{
          label: 'Zurück zur Startseite',
        }"
      />
    </NuxtLayout>
  </UMain>
</template>
